/* Middle Tennessee KDM — password page engine.
   rpm drives everything: the needle, the fill arc, the shift lights, the glow and the
   speed streaks. Typing blips the throttle, submit runs launch control, a wrong
   password stalls. Without JS the form posts normally. */
(function () {
  'use strict';
  var d = document;
  function init() {
    var root = d.querySelector('[data-mt-pw]');
    if (!root || root.__mt) return; root.__mt = 1;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var card = root.querySelector('[data-mt-pw-card]');
    var needle = root.querySelector('[data-mt-pw-needle]');
    var rpmText = root.querySelector('[data-mt-pw-rpm]');
    var gearEl = root.querySelector('[data-mt-pw-gear]');
    var statusEl = root.querySelector('[data-mt-pw-status]');
    var leds = root.querySelectorAll('.mt-pw__led');
    var input = root.querySelector('[data-mt-pw-input]');
    var eye = root.querySelector('[data-mt-pw-eye]');
    var form = d.getElementById('mt-pw-form') || (input && input.form);
    var err = d.getElementById('mt-pw-err');
    var hasError = !!(err && err.textContent.replace(/\s/g, '').length);

    var MAX = 8000, IDLE = 850, SHIFT = 6800;
    var rpm = 0, target = 0, launching = false, lastGear = 'N';

    function base() {
      var n = input ? input.value.length : 0;
      return n ? IDLE + Math.min(n, 12) / 12 * 4300 : IDLE;
    }
    function setState(name) {
      root.classList.toggle('is-armed', name === 'armed');
      if (statusEl) statusEl.textContent = name === 'armed' ? 'Armed' : name === 'launch' ? 'Launch' : name === 'stall' ? 'Stalled' : 'Locked';
    }
    function gear() {
      var n = input ? input.value.length : 0;
      var g = n ? String(Math.min(6, Math.ceil(n / 2))) : 'N';
      if (g !== lastGear && gearEl) { gearEl.textContent = g; gearEl.classList.remove('is-bump'); void gearEl.offsetWidth; gearEl.classList.add('is-bump'); lastGear = g; }
    }
    function paint() {
      var p = Math.max(0, Math.min(1, rpm / MAX));
      root.style.setProperty('--rpm', p.toFixed(4));
      if (needle) needle.style.setProperty('--needle', (-120 + p * 240).toFixed(2) + 'deg');
      if (rpmText) rpmText.textContent = Math.round(rpm / 10) * 10 >= 1000 ? (Math.round(rpm / 10) * 10).toLocaleString('en-US') : String(Math.round(rpm / 10) * 10);
      var lit = Math.round(p / (SHIFT / MAX) * leds.length);
      for (var i = 0; i < leds.length; i++) leds[i].classList.toggle('is-on', i < lit);
      if (!launching) root.classList.toggle('is-shift', rpm >= SHIFT);
    }

    /* reduced motion: static gauge that still reflects typing, instant submit */
    if (reduce) {
      rpm = IDLE; paint();
      if (input) input.addEventListener('input', function () { rpm = base(); paint(); gear(); setState(input.value ? 'armed' : 'locked'); });
      if (hasError) setState('stall');
      bindEye(); return;
    }

    /* engine loop: rev up fast, fall back slowly, idle shimmy */
    var jitter = 0, lastJ = 0;
    function frame(t) {
      if (t - lastJ > 90) { jitter = (Math.random() - .5) * 60; lastJ = t; }
      var goal = target + (launching ? 0 : jitter);
      var k = goal > rpm ? .2 : .07;
      rpm += (goal - rpm) * k;
      paint();
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    /* ignition: the needle sweeps to the stop and back, like a real cluster */
    setTimeout(function () { target = MAX; }, 650);
    setTimeout(function () {
      target = base();
      if (hasError) stall();
      else if (input && !('ontouchstart' in window)) { try { input.focus({ preventScroll: true }); } catch (e) {} }
    }, 1350);

    var blipT;
    if (input) input.addEventListener('input', function () {
      if (launching) return;
      clearTimeout(blipT);
      target = Math.min(MAX - 300, base() + 1700);
      blipT = setTimeout(function () { target = base(); }, 130);
      gear(); setState(input.value ? 'armed' : 'locked');
      if (input.getAttribute('aria-invalid') === 'true' && input.value) { input.removeAttribute('aria-invalid'); if (err) err.textContent = ''; }
    });

    function stall() {
      setState('stall'); target = 0;
      root.classList.remove('is-stall'); void root.offsetWidth; root.classList.add('is-stall');
      setTimeout(function () { root.classList.remove('is-stall'); target = base(); setState('locked'); if (input) input.focus(); }, 1300);
    }

    if (form) form.addEventListener('submit', function (e) {
      if (launching) return;
      if (!input || !input.value) { e.preventDefault(); stall(); return; }
      e.preventDefault(); launching = true; setState('launch');
      target = 7600; root.classList.add('is-shift');
      setTimeout(function () { root.classList.add('is-launch'); target = MAX; }, 650);
      setTimeout(function () { HTMLFormElement.prototype.submit.call(form); }, 1150);
    });

    /* subtle tilt toward the pointer */
    if (card && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      root.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - (r.left + r.width / 2)) / window.innerWidth, y = (e.clientY - (r.top + r.height / 2)) / window.innerHeight;
        card.style.setProperty('--ty', (x * 6).toFixed(2) + 'deg'); card.style.setProperty('--tx', (-y * 6).toFixed(2) + 'deg');
      });
      root.addEventListener('pointerleave', function () { card.style.setProperty('--ty', '0deg'); card.style.setProperty('--tx', '0deg'); });
    }

    /* speed streaks: warp field whose speed and density follow rpm */
    var cv = root.querySelector('[data-mt-pw-fx]');
    if (cv && cv.getContext) {
      var ctx = cv.getContext('2d'), W = 0, H = 0, dpr = 1, parts = [];
      function size() { dpr = Math.min(window.devicePixelRatio || 1, 2); W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
      function spawn(p) { p.a = Math.random() * Math.PI * 2; p.r = Math.random() * 40 + 10; p.s = Math.random() * .6 + .4; p.red = Math.random() < .28; return p; }
      size(); window.addEventListener('resize', size);
      for (var i = 0; i < 170; i++) { var p = spawn({}); p.r = Math.random() * Math.max(W, H); parts.push(p); }
      function draw() {
        var q = Math.max(0, Math.min(1, rpm / MAX));
        ctx.fillStyle = 'rgba(11,14,18,' + (.32 - q * .14) + ')'; ctx.fillRect(0, 0, W, H);
        var cx = W / 2, cy = H * .48, speed = 1.2 + q * q * 26 + (launching ? 18 : 0), maxR = Math.hypot(W, H) * .6;
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i], r0 = p.r; p.r += speed * p.s * (1 + p.r / 320);
          if (p.r > maxR) { spawn(p); continue; }
          var c = Math.cos(p.a), s = Math.sin(p.a), alpha = Math.min(1, p.r / 260) * (.18 + q * .6);
          ctx.strokeStyle = p.red ? 'rgba(215,38,47,' + alpha + ')' : 'rgba(243,244,246,' + alpha * .7 + ')';
          ctx.lineWidth = p.red ? 1.6 : 1; ctx.beginPath(); ctx.moveTo(cx + c * r0, cy + s * r0); ctx.lineTo(cx + c * p.r, cy + s * p.r); ctx.stroke();
        }
        if (!d.hidden) requestAnimationFrame(draw); else setTimeout(function () { requestAnimationFrame(draw); }, 400);
      }
      requestAnimationFrame(draw);
    }

    bindEye();
    function bindEye() {
      if (!eye || !input) return;
      eye.addEventListener('click', function () {
        var show = input.type === 'password';
        input.type = show ? 'text' : 'password';
        eye.textContent = show ? 'Hide' : 'Show';
        eye.setAttribute('aria-pressed', show ? 'true' : 'false');
        input.focus();
      });
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
